export const BSCSCAN_URL = "https://bscscan.com"

export const SAFELAUNCH_URLS = {
  DOCS: "https://docs.safelaunch.io",
  TG: "https://t.me/SafeLaunch_IO",
  TIERS: "https://docs.safelaunch.io/products/safealloc-private-deals/how-it-works-investors",
  SFEX_PANCAKESWAP:
    "https://pancakeswap.finance/swap?outputCurrency=0x5392Ff4a9BD006DC272C1855af6640e17Cc5ec0B",
  BNB_SFEX_LP_PANCAKESWAP:
    "https://exchange.pancakeswap.finance/#/add/BNB/0x5392Ff4a9BD006DC272C1855af6640e17Cc5ec0B",
  TOKEN_SWAP_MEDIUM_POST:
    "https://medium.com/safelaunch-io/safelaunch-to-take-immediate-steps-to-address-a-technical-issue-with-a-new-token-airdrop-and-5bc9749593ad",
  DISCORD: "https://discord.gg/xfZ3YSSkd9",
  TWITTER: "https://twitter.com/safelaunch1",
  IDO_FORM: "https://airtable.com/shrnD90BAUZ7ygO3i",
} as const
